module.exports = __webpack_public_path__ + "img/Mantraz.024f4984.png";